import { Box, Text } from '@chakra-ui/react';

import AuthenticatedPageWrapper from 'app/components/UI/AuthenticatedPageWrapper';
import CompanyDeductionReportsTab from 'app/components/DeductionReports/CompanyDeductionReportsTab';

function DeductionReports() {
  return (
    <AuthenticatedPageWrapper title="Company Deduction Reports">
      <Text as="h2" textStyle="h2" color="brand.darkPurple">
        Company Deduction Reports
      </Text>

      <Box w="full" mt="30px">
        <CompanyDeductionReportsTab />
      </Box>
    </AuthenticatedPageWrapper>
  );
}

export default DeductionReports;
